export default defineNuxtRouteMiddleware(async (to) => {
  const runtimeConfig = useRuntimeConfig()

  if (to.query && to.query['isDeleted']) {
    const ory = useCookie(runtimeConfig.public.ory.sessionCookieName)
    ory.value = null
  }

  await useAuth().init()
})
